import { gql } from '@apollo/client';

export const fetchEntitlementsForFamilyContainerPPC = gql`
  query fetchEntitlementsForFamilyContainerPPC($id: ID!, $filterOptions: [FilterOption]) {
    transactionAccount(id: $id) {
      id
      entitlements(filterOptions: $filterOptions) {
        nodes {
          id
          entitlementNumber
          unitCount
        }
      }
    }
  }
`;
